/**
 * Back in Stock – AJAX form submission.
 * Visibility is handled in Liquid (hidden attribute based on variant.available).
 * Posts to Shopify's native /contact endpoint to subscribe the customer
 * to email marketing and tag them with "bis-variant-{id}".
 */

class BackInStockForm {
  constructor(container) {
    this.form     = container.querySelector('form');
    this.feedback = container.querySelector('[data-bis-feedback]');
    this.form?.addEventListener('submit', e => this.onSubmit(e));
  }

  async onSubmit(event) {
    event.preventDefault();

    const emailInput = this.form.querySelector('[name="contact[email]"]');
    if (!emailInput?.value || !emailInput.checkValidity()) {
      emailInput?.focus();
      return;
    }

    const submitBtn = this.form.querySelector('[type="submit"]');
    submitBtn.disabled = true;
    submitBtn.classList.add('is-loading');

    try {
      const response = await fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(new FormData(this.form))
      });

      if (response.ok) {
        this.showFeedback(
          window.bisStrings?.success || 'Super! Wir benachrichtigen dich, sobald das Produkt wieder verfügbar ist.',
          'success'
        );
        emailInput.value = '';
      } else {
        this.showFeedback(
          window.bisStrings?.error || 'Fehler. Bitte versuche es später erneut.',
          'error'
        );
        submitBtn.disabled = false;
      }
    } catch (err) {
      console.error('[BIS] submit error:', err);
      this.showFeedback(
        window.bisStrings?.error || 'Fehler. Bitte versuche es später erneut.',
        'error'
      );
      submitBtn.disabled = false;
    } finally {
      submitBtn.classList.remove('is-loading');
    }
  }

  showFeedback(text, type) {
    if (!this.feedback) return;
    this.feedback.textContent = text;
    this.feedback.className   = `back-in-stock__feedback back-in-stock__feedback--${type}`;
    this.feedback.hidden      = false;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-back-in-stock]').forEach(el => {
    new BackInStockForm(el);
  });
});
